import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExgPanelComponent, ExgSelectComponent} from 'exc-controls-v2';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {Editor} from 'tinymce';

@Component({
  selector: 'app-receipt-review',
  templateUrl: './receipt-review.component.html',
})
export class ReceiptReviewComponent
  extends ExcTranslation
  implements OnInit, AfterViewInit
{
  @Input()
  workspace: any;
  @Input()
  canEdit = false;
  @Input()
  checkview = {} as any;
  @Input()
  details = {} as any;

  @ViewChild('VCCommentTArea', { read: ElementRef })
  VCCommentTArea!: ElementRef;
  @ViewChild('VCComment', { read: ElementRef }) VCComment!: ElementRef;
  @ViewChild('VCReason') VCReason!: ExgSelectComponent;
  @ViewChild('VCExgPanelReasons') VCExgPanelReasons!: ExgPanelComponent;

  // @ts-ignore
  MCEinit: any = {
    placeholder: '',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,
    plugins: ['paste'],

    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },

    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },

    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',
    toolbar:
      'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons',
    contextmenu: 'bold italic underline strikethrough| \
    alignleft aligncenter alignright alignjustify | \
    forecolor backcolor emoticons | EXAKTFieldInsertPosition2 EXAKTFieldInsertSummierung',
    setup: (editor: any) => {
      editor.ui.registry.addMenuItem('EXAKTFieldInsertPosition', {
        text: 'Positionen einfügen',
        onAction: () => {
          const styleTdOdd = 'background: #DEDEDE;';

          let tableHtml = `<div><table><tbody><tr>
                  <td style="border-bottom: 1px solid #000000; text-align: left"><strong>${this.getRessource('positions.Title')}</strong></td>
                  <td style="border-bottom: 1px solid #000000; text-align: right"><strong>${this.getRessource('positions.PositionCount')}</strong></td>
                  <td style="border-bottom: 1px solid #000000; text-align: right"><strong>${this.getRessource('positions.OriginalValue')}</strong></td>
                  <td style="border-bottom: 1px solid #000000; text-align: right"><strong>${this.getRessource('lineup.Passing')}</strong></td>
                  <td style="text-align: right; color: #ffffff;">${this.getRessource('positions.CorrectionValue')}</td>
                 </tr>`;

          for (let i = 0; i < this.checkview.receiptCorrectionTable.data.length; i++) {
            const corrElement = this.checkview.receiptCorrectionTable.data[i];

            tableHtml =
              tableHtml +
              `<tr><td style="${i % 2 === 1 ? styleTdOdd : ''}text-align: left">${corrElement.rcptCorTitle && corrElement.rcptCorTitle.length > 0 ? corrElement.rcptCorTitle : 'Kein Titel'}</td>
                      <td style="${i % 2 === 1 ? styleTdOdd : ''}text-align: right">${corrElement.inputValuesCount} </td>
                      <td style="${i % 2 === 1 ? styleTdOdd : ''}text-align: right">${corrElement.rcptCorAmountOrig} €</td>
                      <td style="${i % 2 === 1 ? styleTdOdd : ''}text-align: right">${corrElement.rcptCorAmountCorr} €</td>
                      <td style="text-align: right; color: #ffffff;">${corrElement.rcptCorAmountCorr} €</td></tr>`;
          }


          this.reviewClone.rcptReviewComment =
            this.reviewClone.rcptReviewComment + tableHtml.replace('\n', '') + '</tbody></table></div><br/><br/>';
        }
      });
      editor.ui.registry.addMenuItem('EXAKTFieldInsertPosition2', {
        text: 'Positionstabelle mit Begründung einfügen',
        onAction: () => {
          let tableHtml = `<div><table style="width:90%; border-collapse:collapse; margin-bottom:20px;"><tbody>`;

          for (const corrElement of this.checkview.receiptCorrectionTable.data) {
            tableHtml =
              tableHtml +
              `<tr>
                    <th colspan="4" style="border:1px solid #999; padding:6px 8px; background:#eee; text-align:left;">
                      ${corrElement.rcptCorTitle && corrElement.rcptCorTitle.length > 0 ? corrElement.rcptCorTitle : 'Kein Titel'}
                    </th>
                  </tr>
                  <tr>
                    <th style="width:20%; border:1px solid #999; padding:6px 8px; text-align:left;"></th>
                    <th style="width:20%; border:1px solid #999; padding:6px 8px; text-align:left;">${this.getRessource('positions.OriginalValue')}</th>
                    <th style="width:20%; border:1px solid #999; padding:6px 8px; text-align:left;">${this.getRessource('lineup.Passing')}</th>
                    <th style="width:40%; border:1px solid #999; padding:6px 8px; text-align:left;">${this.getRessource('lineup.Description')}</th>
                  </tr>
                  <tr>
                    <td style="border:1px solid #999; padding:6px 8px;">Einzelpreis</td>
                    <td style="border:1px solid #999; padding:6px 8px; text-align:right;">
                      ${corrElement.rcptCorValueCorr.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                    </td>
                    <td style="border:1px solid #999; padding:6px 8px; text-align:right;">
                      ${corrElement.rcptCorValueOrig.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                    </td>
                    <td rowspan="3" style="border:1px solid #999; padding:6px 8px; vertical-align:top;">
                      ${corrElement.rcptCorDesc}
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #999; padding:6px 8px;">Menge</td>
                    <td style="border:1px solid #999; padding:6px 8px; text-align:right;">${corrElement.rcptCorMengeOrig}</td>
                    <td style="border:1px solid #999; padding:6px 8px; text-align:right;">${corrElement.rcptCorMengeCorr}</td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #999; padding:6px 8px;">
                      Summe <span style="font-size:0.9em; color:#555;">(netto)</span>
                    </td>
                    <td style="border:1px solid #999; padding:6px 8px; text-align:right;">
                      ${corrElement.rcptCorAmountOrig.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                    </td>
                    <td style="border:1px solid #999; padding:6px 8px; text-align:right;">
                      ${corrElement.rcptCorAmountCorr.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                    </td>
                  </tr>`;
          }


          this.reviewClone.rcptReviewComment =
            this.reviewClone.rcptReviewComment + tableHtml.replace('\n', '') + '</tbody></table></div><br/><br/>';
        }
      });
      editor.ui.registry.addMenuItem('EXAKTFieldInsertSummierung', {
        text: 'Summierung einfügen',
        onAction: () => {
          this.reviewClone.rcptReviewComment = `${this.reviewClone.rcptReviewComment}` + `<div><table><tbody>` + `<tr>
                      <td></td>
                      <td style="text-align: right"><strong>${this.getRessource('lineup.ReceiptValue')}</strong></td>
                      <td style="text-align: right"><strong>${this.getRessource('lineup.detected')}</strong></td>
                      <td style="text-align: right"><strong>${this.getRessource('lineup.Corrections')}</strong></td>
                      <td style="text-align: right"><strong>${this.getRessource('lineup.Passing')}</strong></td>
                      <td style="text-align: right; color: #ffffff;">${this.getRessource('lineup.Passing')}</td>
                     </tr>` + `<tr>
                      <td style="border-right: #010101 2px solid">
                        ${this.enumSvc.getFieldCaption('Receipt', 'rcptNetSum')}
                      </td>
                      <td style="text-align: right">
                        ${this.workspace.reviewPreCalc.receiptNetto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €

                      </td>
                      <td style="text-align: right">
                        ${this.workspace.reviewPreCalc.originalNetto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                      </td>
                      <td style="text-align: right">
                        ${(-1 * this.workspace.reviewPreCalc.resultNetto).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                      </td>
                      <td style="text-align: right">
                        ${this.workspace.reviewPreCalc.sumCorrNetto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                      </td>
                      <td style="text-align: right; color: #ffffff;">
                        ${this.workspace.reviewPreCalc.resultNetto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                      </td>
                     </tr>` + `<tr>
                      <td style="border-right: #010101 2px solid">${this.enumSvc.getFieldCaption('Receipt', 'rcptVATRate')} [${this.checkview.VCreceipt.receipt?.rcptVATRate || '-'}%]</td>
                      <td style="text-align: right">${this.workspace.reviewPreCalc.receiptVat.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €</td>
                      <td style="text-align: right">${this.workspace.reviewPreCalc.originalVat.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €</td>
                      <td style="text-align: right">${(-1 * this.workspace.reviewPreCalc.resultVAT).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €</td>
                      <td style="text-align: right">${this.workspace.reviewPreCalc.sumCorrVat.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €</td>
                      <td style="text-align: right; color: #ffffff;">${this.workspace.reviewPreCalc.resultVAT.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                     </tr>` + `<tr>
                      <td style="border-right: #010101 2px solid; border-top: #010101 1px solid;">
                        <strong>
                          ${this.enumSvc.getFieldCaption('Receipt', 'rcptGrossSum')}
                        </strong>
                      </td>
                      <td style="text-align: right; border-top: #010101 1px solid;">
                        <strong>
                           ${this.workspace.reviewPreCalc.receiptBrutto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                        </strong>
                      </td>
                      <td style="text-align: right; border-top: #010101 1px solid;">
                        ${this.workspace.reviewPreCalc.originalBrutto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                      </td>
                      <td style="text-align: right; border-top: #010101 1px solid;">
                        ${(-1 * this.workspace.reviewPreCalc.resultBrutto).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                      </td>
                      <td style="text-align: right; border-top: #010101 1px solid;">
                        <strong>
                          ${this.workspace.reviewPreCalc.sumCorrBrutto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                        </strong>
                      </td>
                      <td style="text-align: right; color: #ffffff;">
                        <strong>
                          ${this.workspace.reviewPreCalc.resultBrutto.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €
                        </strong>
                      </td>
                     </tr>` + `</tbody></table></div><br/><br/>`;
        }
      });
    }
  };
  MCEinitDisabled: any = {
    placeholder: '',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,
    toolbar: '',
    contextmenu: '',
    setup: (editor: Editor) => {

    }
  };
  _reviewEditMode = false;
  reviewClone = {
    rcptReviewComment: '',
    rcptCommentNext: '',
    rcptReviewDate: Date.now(),
    rcptReviewReasons: undefined as any ,
    rcptReviewHints: undefined as any,
    rcptSumTable: true,
    rcptPosTable: false
  };
  hintCount = 0;

  get reviewEditMode(): boolean {
    return this._reviewEditMode ? this._reviewEditMode : false;
  }
  set reviewEditMode(value: boolean) {
    if (value && this.checkview) {
      this.checkview.checkChanges = true;
    }
    if (this.canEdit) {
      this._reviewEditMode = value;
    }
  }

  get reviewChanged(): boolean {
    return JSON.stringify(this.review) !== JSON.stringify(this.reviewClone);
  }

  rcptReviewReasonList = [] as any[];
  rcptReviewHintList = [] as any[];
  reviewReason = '';

  review = {
    rcptReviewTextLCD: 0,
    rcptReviewTextLCU: '',
    rcptReviewComment: '',
    rcptCommentNext: '',
    rcptReviewDate: '',
    rcptReviewReasons: '',
    rcptReviewHints: '',
    rcptSumTable: true,
    rcptPosTable: false,
  };
  conditions = {
    form: {
      condition: '',
      hint: '',
      accepted: false,
      LCU: '',
      LCD: undefined,
      qsAccepted: false,
      qsLCU: '',
      qsLCD: undefined,
      get showCondition(): boolean {
        return true;
      },
      showAccept: true
    },
    preCalc: {
      receiptNetto: 0.0,
      receiptVat: 0,
      receiptBrutto: 0.0,
      diffBrutto: 0.0,
      diffNetto: 0.0,
      diffVat: 0.0,
      originalBrutto: 0.0,
      originalNetto: 0.0,
      originalVat: 0.0,
      resultBrutto: 0.0,
      resultNetto: 0.0,
      resultVAT: 0.0,
      corrLength: 0,
    },
    header: 'Bitte vor Abschluss bestätigen:',
    data: [
      {
        condition:
          'Keine Erfassung der Rechnungs-Netto/-Bruttosumme',
        hint: 'Tab 1: Details - Felder: Brutto-/ Netto-Summe',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            this.conditions.preCalc.receiptNetto === 0 ||
            this.conditions.preCalc.receiptBrutto === 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Erfasste Rechnungspositionen Beträge ungleich Gesamtsumme',
        hint: 'Gesamtsumme der Stammdaten ist ungleich Tab 2 - Summe Originalwerte',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return !this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            (!(
              this.conditions.preCalc.receiptNetto === 0 ||
              this.conditions.preCalc.receiptBrutto === 0
            ) &&
              (
                (
                  Math.round((
                    (this.conditions.preCalc.receiptNetto - this.conditions.preCalc.originalNetto) + Number.EPSILON)
                      * 100
                  ) / 100) === 0
              )
            ) ||
            this.conditions.preCalc.corrLength === 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Keine Rechnungspositionen erfasst.',
        hint: 'Tab 2: Position mit Orignalwert und ggf. Korrekturen',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            this.conditions.preCalc.corrLength === 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Summe des Freigabebetrags ist größer als die Belegsumme',
        hint: 'Tab 2: Positionen - Summe der Freigabebeträge > Summe Rechnungssumme',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            this.conditions.preCalc.resultNetto < 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Prüfungsergebnis erfassen',
        hint: 'Es wurde noch kein Prüfungsergebnis erfasst',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            this.review.rcptReviewReasons.length === 0
          );
        },
        showAccept: false
      },
    ],
    canChangeState(): boolean {
      return (
        ExcCoreModule.Array.ExistsObject(
          this.visibleConditions(),
          'accepted',
          false
        )
      );
    },
    visibleConditions(): any[] {
      return ExcCoreModule.Array.GetAll(this.data, 'showCondition', true);
    },
    acceptedAll(): boolean {
      const conditions = this.visibleConditions();
      return conditions.length > 0
        ? ExcCoreModule.Array.GetAll(conditions, 'accepted', false).length === 0
        : true;
    },
    reset(): void {
      const conditions = this.visibleConditions();
      conditions.forEach((condition: any) => {
        condition.accepted = false;
      });
    },
  };

  constructor(
    private appSrv: ApplicationService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    // this.VCCommentTArea.nativeElement.firstChild.firstChild.focus();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    const defaultComment = '<p>Sehr geehrte Damen und Herren,</p>' +
      '<br><br><p>Mit freundlichen Grüßen</p>' +
      '<p>' + (this.details.taskDetails.Bearbeiter && this.details.taskDetails.Bearbeiter.length > 0 ?
        this.details.taskDetails.Bearbeiter : '')
      + '</p>';

    if (this.workspace) {
      if (this.workspace.receiptData) {

        this.review = {
          rcptReviewTextLCD: this.workspace.receiptData.rcptReviewTextLCD || Date.now(),
          rcptReviewTextLCU: this.workspace.receiptData.rcptReviewTextLCU || '',
          rcptReviewReasons: this.workspace.receiptData.rcptReviewReasons || '',
          rcptReviewHints: this.workspace.receiptData.rcptReviewHints || '',
          rcptReviewComment: this.workspace.receiptData.rcptReviewComment && this.workspace.receiptData.rcptReviewComment.length > 0
            ? this.workspace.receiptData.rcptReviewComment
            : defaultComment,
          rcptCommentNext: this.workspace.receiptData.rcptCommentNext
            ? this.workspace.receiptData.rcptCommentNext
            : '',
          rcptReviewDate:
            this.workspace.receiptData.rcptReviewDate &&
            this.workspace.receiptData.rcptReviewDate > 0
              ? this.workspace.receiptData.rcptReviewDate
              : Date.now(),
          rcptSumTable: this.workspace.receiptData.rcptSumTable === null ? true : this.workspace.receiptData.rcptSumTable,
          rcptPosTable: this.workspace.receiptData.rcptPosTable || false
        };

        this.initEnumerations();
        this.getReviewReason();
        this.reviewClone = this.appSrv.helperObj.clone(this.review);
      }

      if (this.workspace.reviewPreCalc) {
        this.conditions.preCalc = this.workspace.reviewPreCalc;
      }
    }


  }

  switchEditMode(canSwitch?: boolean): void {
    if (canSwitch) {
      this.reviewEditMode = !this.reviewEditMode;
    }

    if (this.reviewEditMode) {
      if (ExcCoreModule.Array.GetAll(this.rcptReviewReasonList, 'enmValue', true).length === 0) {
        this.changeViewStatePanel();
      }
    }
  }

  updateReviewReasons(reason: any): void {
    for (const rcptReviewReasonListElement of this.getrcptReviewReasonList()) {
      if (rcptReviewReasonListElement.enmIdent !== reason.enmIdent) {
        rcptReviewReasonListElement.enmValue = false;
      }
    }

    this.reviewClone.rcptReviewReasons = JSON.stringify(
      ExcCoreModule.Array.GetAll(this.rcptReviewReasonList, 'enmValue', true)
    );

    this.getReviewReason();

    if (this.reviewEditMode) {
      if (ExcCoreModule.Array.GetAll(this.rcptReviewReasonList, 'enmValue', true).length > 0) {
        this.changeViewStatePanel();
      }
    }
  }

  updateReviewHints(reason: any): void {
    const hintList = ExcCoreModule.Array.GetAll(this.rcptReviewHintList, 'enmValue', true);

    this.reviewClone.rcptReviewHints = JSON.stringify(hintList);
    this.hintCount = hintList.length;


  }

  initEnumerations(): void {
    this.rcptReviewReasonList = [];
    this.rcptReviewHintList = [];

    this.enumSvc
      .getEnumerationList('ReceiptReviewReason')
      .forEach((enm: any) => {
        enm.enmValue = false;

        if (this.review.rcptReviewReasons) {
          if (this.review.rcptReviewReasons.length > 0) {
            enm.enmValue = ExcCoreModule.Array.ExistsObject(this.review.rcptReviewReasons, 'enmIdent', enm.enmIdent);
          }
        }
        const obj = {
          enmValue: enm.enmValue,
          enmText: enm.enmText,
          uiTooltip: enm.uiTooltip,
          enmTextA: enm.enmTextA,
          enmIdent: enm.enmIdent,
        };

        this.rcptReviewReasonList.push(obj);
      });


    this.enumSvc
      .getEnumerationList('ReceiptReviewHint')
      .forEach((enm: any) => {
        enm.enmValue = false;
        if (this.review.rcptReviewHints) {
          if (this.review.rcptReviewHints.length > 0) {
            enm.enmValue = ExcCoreModule.Array.ExistsObject(this.review.rcptReviewHints, 'enmIdent', enm.enmIdent);
          }
        }
        const obj = {
          enmValue: enm.enmValue,
          enmText: enm.enmText,
          uiTooltip: enm.uiTooltip,
          enmTextA: enm.enmTextA,
          enmIdent: enm.enmIdent,
        };
        this.rcptReviewHintList.push(obj);
      });

    this.hintCount = ExcCoreModule.Array.GetAll(this.rcptReviewHintList, 'enmValue', true).length;

  }

  getrcptReviewReasonList(): any[] {
    return this.rcptReviewReasonList.sort((a, b) =>
      a.enmText.localeCompare(b.enmText)
    ).filter((enm: any) => enm.enmIdent !== 80);
  }

  getrcptReviewHintList(): any[] {
    return this.rcptReviewHintList.sort((a, b) =>
      a.enmText.localeCompare(b.enmText)
    );
  }

  getReviewReason(): void {
    if (
      ExcCoreModule.Array.GetAll(this.rcptReviewReasonList, 'enmValue', true)
      && ExcCoreModule.Array.GetAll(this.rcptReviewReasonList, 'enmValue', true).length > 0
    ) {
      this.reviewReason = ExcCoreModule.Array.GetAll(this.rcptReviewReasonList, 'enmValue', true)[0].enmText;
      return;
    }

    this.reviewReason = '';
  }

  changeViewStatePanel(): void {
    const inputCheckbox = document.getElementById(this.VCExgPanelReasons.id) as HTMLInputElement;
    if (inputCheckbox) {
      inputCheckbox.checked = !inputCheckbox.checked;
    }
  }
}
